export default __webpack_public_path__ + "static/media/bot-mini.9884a1de.png";